import i18n, {changeLanguage, use} from 'i18next'
import {initReactI18next} from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-http-backend'
import storage from 'services/storage'
import en from './locales/en'
import he from './locales/he'
import store, {setLanguage} from 'store/Store'

use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: {translation: en},
            he: {translation: he},
        },
        fallbackLng: 'he',
        debug: process.env.NODE_ENV === 'development',
        interpolation: {
            escapeValue: false,
        },
        react: {
            useSuspense: true,
        },
    })

export const getSupportedLanguages = () => Object.keys(i18n.options.resources)

export const setLocale = (lang) => {
    store.dispatch(setLanguage(lang))

    if (i18n.language === lang) return
    changeLanguage(lang)

    if (lang === 'he') {
        storage.setLanguage('he')
    } else {
        storage.setLanguage('en')
    }
}

let activeLanguage = storage.getLanguage()
if (!activeLanguage) {
    storage.setLanguage('he')
    activeLanguage = 'he'
}

setLocale(activeLanguage)

export default i18n
